import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navigation.css';

const Navigation = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          🏎️ CarAuction
        </Link>

        <button
          className="nav-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>

        <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          {user && (
            <>
              <Link to="/dashboard" className="nav-link">
                Dashboard
              </Link>
              <Link to="/list-vehicle" className="nav-link">
                List Vehicle
              </Link>
              <Link to="/auctions" className="nav-link">
                Auctions
              </Link>
              <Link to="/payouts" className="nav-link">
                Payouts
              </Link>
              <Link to="/analytics" className="nav-link">
                Analytics
              </Link>
              <Link to="/messages" className="nav-link">
                Messages
              </Link>
              <div className="nav-user">
                <span className="nav-username">{user.firstName}</span>
                <button onClick={handleLogout} className="btn btn-secondary btn-small">
                  Logout
                </button>
              </div>
            </>
          )}
          {!user && (
            <>
              <Link to="/login" className="nav-link">
                Login
              </Link>
              <Link to="/signup" className="nav-link">
                <button className="btn btn-primary btn-small">Sign Up</button>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
